const RATING_LABEL = {
  excellent: '300+ DPI · Excellent',
  good: '225–299 DPI · Good',
  fair: '150–224 DPI · Fair',
  poor: '<150 DPI · Low-res',
};

const RATING_CLASS = {
  excellent: 'chip-good',
  good: 'chip-good',
  fair: 'chip-fair',
  poor: 'chip-poor',
};

export function QualityChip({ rating }) {
  if (!rating) return null;
  return (
    <span className={`chip ${RATING_CLASS[rating] || 'chip-fair'}`}>
      <span className="chip-dot" />{RATING_LABEL[rating] || rating}
    </span>
  );
}
